import { useEffect } from 'react';

interface UseEffectIfProps {
  effect: () => void;
  watchList: any[];
  condition: boolean | (() => boolean);
}

export const useEffectIf = ({ effect, watchList, condition }: UseEffectIfProps) => {
  useEffect(() => {
    const doesConditionMatch =
      typeof condition === 'function' ? condition() : condition;
    if (!doesConditionMatch) {
      return;
    }

    const cleanup = effect();
    if (typeof cleanup === 'function') {

      return cleanup;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, watchList);
};
